var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.78 10.532a.747.747 0 0 0 0-1.06l-4-4.003a.75.75 0 0 0-1.06 1.06l2.72 2.718-7.69.003A.75.75 0 0 0 7 10c0 .416.334.75.75.75h7.69l-2.719 2.72a.75.75 0 0 0 1.06 1.06zM7.25 4.5c.415 0 .75-.334.75-.75A.75.75 0 0 0 7.25 3h-2.5A2.75 2.75 0 0 0 2 5.75v8.5A2.75 2.75 0 0 0 4.75 17h2.5c.415 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75h-2.5c-.691 0-1.25-.559-1.25-1.25v-8.5c0-.69.559-1.25 1.25-1.25z"
  })));
};
export default SvgLogOut;